(function () {
    "use strict";

    angular.module('app').factory('utils', UtilsFactory);

    function UtilsFactory() {
        return {
            getAllSelectedItems: (list) => list.filter(el => el.active === true),
            removeObject: removeObject
        };

        /**
         * Removes an object from an array by reference
         * @param {Array} list the array from which we want to remove an item 
         * @param {Object} item  the item to delete
         * @returns true when an item was removed
         */
        function removeObject(list, item) {
            const index = list.indexOf(item);
            if (index === -1)
                return false;

            list.splice(index, 1);
            return true;
        }
    }
})();